module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Warning-2-ecb2ce1bb2550e17fc95850b04d74b04.svg";